(() => {
  const SECTION_SELECTOR = '.oddit-section-full-width-carousel';
  const sectionState = new Map();

  function initSection(section) {
    const slides = section.querySelectorAll('.oddit-section-full-width-carousel__slide');
    const dots = section.querySelectorAll('.oddit-section-full-width-carousel__dot');
    const prevBtn = section.querySelector('.oddit-section-full-width-carousel__arrow--prev');
    const nextBtn = section.querySelector('.oddit-section-full-width-carousel__arrow--next');
    const track = section.querySelector('.oddit-section-full-width-carousel__track');

    if (slides.length < 2) return;

    let currentIndex = 0;
    const totalSlides = slides.length;

    function goToSlide(index) {
      if (index < 0) index = totalSlides - 1;
      if (index >= totalSlides) index = 0;

      slides[currentIndex].classList.remove('oddit-section-full-width-carousel__slide--active');
      slides[currentIndex].setAttribute('aria-hidden', 'true');
      dots[currentIndex].classList.remove('oddit-section-full-width-carousel__dot--active');
      dots[currentIndex].removeAttribute('aria-current');

      currentIndex = index;

      slides[currentIndex].classList.add('oddit-section-full-width-carousel__slide--active');
      slides[currentIndex].removeAttribute('aria-hidden');
      dots[currentIndex].classList.add('oddit-section-full-width-carousel__dot--active');
      dots[currentIndex].setAttribute('aria-current', 'true');
    }

    function advanceSlide() {
      goToSlide(currentIndex + 1);
    }

    // Arrow navigation
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        goToSlide(currentIndex - 1);
        resetAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        goToSlide(currentIndex + 1);
        resetAutoplay();
      });
    }

    // Dot navigation
    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.getAttribute('data-slide-index'), 10);
        goToSlide(index);
        resetAutoplay();
      });
    });

    // Touch/swipe support
    let startX = 0;
    if (track) {
      track.addEventListener('touchstart', (e) => {
        startX = e.touches[0].pageX;
      }, { passive: true });

      track.addEventListener('touchend', (e) => {
        const deltaX = e.changedTouches[0].pageX - startX;
        if (Math.abs(deltaX) > 50) {
          if (deltaX > 0) {
            goToSlide(currentIndex - 1);
          } else {
            goToSlide(currentIndex + 1);
          }
          resetAutoplay();
        }
      }, { passive: true });
    }

    // Autoplay (RAF-based)
    let rafId = null;
    let lastAdvance = performance.now();
    const autoplayEnabled = section.dataset.autoplay === 'true';
    const speedSeconds = parseInt(section.dataset.autoplaySpeed, 10) || 5;
    const intervalMs = speedSeconds * 1000;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function tick(now) {
      if (now - lastAdvance >= intervalMs) {
        advanceSlide();
        lastAdvance = now;
      }
      rafId = requestAnimationFrame(tick);
    }

    function startAutoplay() {
      if (rafId || !autoplayEnabled || reducedMotion.matches) return;
      lastAdvance = performance.now();
      rafId = requestAnimationFrame(tick);
    }

    function stopAutoplay() {
      cancelAnimationFrame(rafId);
      rafId = null;
    }

    function resetAutoplay() {
      if (!autoplayEnabled || reducedMotion.matches) return;
      stopAutoplay();
      lastAdvance = performance.now();
      startAutoplay();
    }

    // Pause on visibility change
    function handleVisibility() {
      document.hidden ? stopAutoplay() : startAutoplay();
    }
    document.addEventListener('visibilitychange', handleVisibility);

    // Pause on hover/focus
    if (track) {
      track.addEventListener('mouseenter', stopAutoplay);
      track.addEventListener('mouseleave', startAutoplay);
      track.addEventListener('focusin', stopAutoplay);
      track.addEventListener('focusout', startAutoplay);
      track.addEventListener('touchstart', stopAutoplay, { passive: true });
      track.addEventListener('touchend', () => {
        lastAdvance = performance.now();
        startAutoplay();
      }, { passive: true });
    }

    // Pause on reduced motion change
    function handleReducedMotion(e) {
      e.matches ? stopAutoplay() : startAutoplay();
    }
    reducedMotion.addEventListener('change', handleReducedMotion);

    // Start autoplay
    startAutoplay();

    // Store state for cleanup
    sectionState.set(section.id || section, {
      destroy() {
        stopAutoplay();
        document.removeEventListener('visibilitychange', handleVisibility);
        reducedMotion.removeEventListener('change', handleReducedMotion);
      }
    });
  }

  function destroySection(section) {
    const state = sectionState.get(section.id || section);
    if (!state) return;
    state.destroy();
    sectionState.delete(section.id || section);
  }

  // Initialize all instances
  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  // Shopify theme editor events
  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();